import { render, staticRenderFns } from "./TabelaDadosFinanceirosPj.vue?vue&type=template&id=32518f58&lang=pug"
import script from "./TabelaDadosFinanceirosPj.vue?vue&type=script&lang=js"
export * from "./TabelaDadosFinanceirosPj.vue?vue&type=script&lang=js"
import style0 from "./TabelaDadosFinanceirosPj.vue?vue&type=style&index=0&id=32518f58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports